<template>
	<div class="sa-prescrizione-card">
		<div class="sa-prescrizione-header">
			<div class="header-left">
				<div class="sa-prescrizione-header-title">Elastometro</div>
				<div class="sa-prescrizione-header-subtitle">Configurazione Composizione</div>
			</div>
			<div class="header-right">
				<div style="height: 100% !important; margin-bottom: 2px">
					<div class="sa-prescrizione-header-title" style="margin-bottom: 2px; font-size: 12px">Via di
						Somministrazione</div>
					<select class="sa-prescrizione-input-header text-center" style="width: 100%"
						v-model="viaSomministrazione">
						<option :value="null">- Seleziona -</option>
						<option value="Endovena">Endovena</option>
						<option value="Sottocutaneo">Sottocutaneo</option>
					</select>
				</div>

				<div>
					<div class="sa-prescrizione-header-title text-center"
						style="margin-bottom: 2px; font-size: 12px; width: 100%">Durata</div>
					<div class="d-flex align-items-center justify-content-end w-100" style="gap: 4px">
						<b-form-input class="sa-prescrizione-input-header-custom text-center"
							style="width: 45px; height: 20%" v-model.number="ora" placeholder="HH"> </b-form-input>
						<b class="mx-1">:</b>
						<select class="sa-prescrizione-input-header text-center" style="width: 55px" v-model="minuto"
							@change="onChangeOraMinuto('minuto', minuto)">
							<option :value="null">mm</option>
							<option value="00">00</option>
							<option v-for="m in 60" :key="m" :value="padStartCustom(m, 2, '0')">
								{{ padStartCustom(m, 2, "0") }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<!-- <div style="text-align: right">
				<div class="sa-prescrizione-header-subtitle">Velocità</div>
				<div style="font-weight: bold">40 ml/h</div>
			</div> -->
		</div>
		<div class="sa-prescrizione-body">
			<div v-for="(item, index) in prescription.components" :key="index"
				:class="[item.veicolo ? 'sa-prescrizione-item-vehicle' : 'sa-prescrizione-item-additive']"
				class="sa-prescrizione-item">
				<div class="sa-prescrizione-input-group" style="flex: 3">
					<label class="sa-label-data">{{ item.veicolo ? "Veicolo" : "Additivo" }}</label>
					<!-- <input class="sa-prescrizione-input" v-model="item.drugName" placeholder="Cerca farmaco..." /> -->
					<div class="sa-prescrizione-search-wrapper">
						<input class="sa-prescrizione-input sa-prescrizione-input-readonly" v-model="item.prescrizione"
							readonly placeholder="Seleziona un farmaco..." />

						<button @click="openRicercaFamraco(index)" class="sa-prescrizione-btn-search"
							title="Cerca in Federfarma">
							<i class="fas fa-search"></i>
						</button>
					</div>
				</div>

				<div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
					<label class="sa-label-data">Dose</label>
					<input class="sa-prescrizione-input" type="number" v-model="item.quantita" />
				</div>

				<div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
					<label class="sa-label-data">Unità</label>
					<select class="sa-prescrizione-input" v-model="item.unitaMisura">
						<option v-for="misura of magazzinoArticoliUnitaMisuraOptions" :key="misura.id"
							:value="misura.id">{{
								misura.descrizioneMultiplo }}</option>
					</select>
				</div>

				<button v-if="!item.veicolo" @click="removeComponent(index)" class="sa-prescrizione-btn-remove">
					<i class="fas fa-trash-alt"></i>
				</button>
			</div>

			<button @click="addComponent" class="sa-prescrizione-btn-add"><i class="fas fa-plus"></i> Aggiungi farmaco
				alla miscela</button>
		</div>

		<div class="sa-prescrizione-footer">
			<div class="sa-prescrizione-total-text">
				<!-- Volume Finale: <span class="sa-prescrizione-total-value">{{ totalVolume }} ml</span> -->
			</div>
			<button @click="onClickConfermaPrescrizione" class="sa-prescrizione-btn-confirm">Conferma Farmaci</button>
		</div>
	</div>
</template>

<script>
import MagazzinoMixins from "../../../magazzino/mixins/MagazzinoMixins";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
	mixins: [UtilityMixin, MagazzinoMixins],
	components: {},
	data() {
		return {
			totalVolume: "",
			minuto: null,
			ora: null,
			orarioScelto: null,
			durata: "00:00",

			viaSomministrazione: null,
			selectedIndex: null,
			prescription: {
				params: { durata: null, viaSomministrazione: null },
				components: [
					{ formaFarmaceutica: null, codiceProdotto: null, atcGmp: null, prescrizione: null, quantita: 0, unitaMisura: "ml", costo: 0.0, veicolo: true },
					//{ prescrizione: "KCl (Potassio Cloruro)", dose: 20, unit: "mEq", isVehicle: false },
				],
			},
		};
	},
	mounted() {
		this.mangazzinoArticoliUnitaMisuraLoadData();
	},
	watch: {
		viaSomministrazione: function (params) {
			this.prescription.params["viaSomministrazione"] = params;
		},
	},
	methods: {
		addComponent() {
			this.prescription.components.push({
				formaFarmaceutica: null,
				codiceProdotto: null,
				atcGmp: null,
				prescrizione: "",
				quantita: 0,
				unitaMisura: null,
				costo: 0.0,
				veicolo: false,
			});
		},
		openRicercaFamraco(index) {
			this.selectedIndex = index;
			this.$emit("openRicercaFamraco");
		},
		setSelectionFarmaco(schedaFarmaco) {
			if (this.selectedIndex === 0) {
				if (this.checkIsVehicle(schedaFarmaco.atcGmp)) {
					this.prescription.components[this.selectedIndex].codiceProdotto = schedaFarmaco.codiceProdotto;
					this.prescription.components[this.selectedIndex].atcGmp = schedaFarmaco.atcGmp;
					this.prescription.components[this.selectedIndex].costo = schedaFarmaco.euroPrezzo1;
					this.prescription.components[this.selectedIndex].formaFarmaceutica = schedaFarmaco.formaFarmaceutica.descrizione;
					this.prescription.components[this.selectedIndex].prescrizione = schedaFarmaco.descrizione;
					let doseUnita = this.parseDrugDose(schedaFarmaco.descrizione);
					this.prescription.components[this.selectedIndex].quantita = doseUnita.value;
					this.prescription.components[this.selectedIndex].unitaMisura = doseUnita.unit;
				} else {
					this.$bvToast.toast("Il farmaco selezionato non è un veicolo, i veicoli sono identificati con i codici ATC: 'B05A', 'B05B', 'V07AB'", {
						title: "ATTENZIONE",
						variant: "danger",
						solid: true,
					});
				}
			} else {
				this.prescription.components[this.selectedIndex].codiceProdotto = schedaFarmaco.codiceProdotto;
				this.prescription.components[this.selectedIndex].atcGmp = schedaFarmaco.atcGmp;
				this.prescription.components[this.selectedIndex].costo = schedaFarmaco.euroPrezzo1;
				this.prescription.components[this.selectedIndex].formaFarmaceutica = schedaFarmaco.formaFarmaceutica.descrizione;
				this.prescription.components[this.selectedIndex].prescrizione = schedaFarmaco.descrizione;
				let doseUnita = this.parseDrugDose(schedaFarmaco.descrizione);
				this.prescription.components[this.selectedIndex].quantita = doseUnita.value;
				this.prescription.components[this.selectedIndex].unitaMisura = doseUnita.unit;
			}
		},
		checkIsVehicle(atcCode) {
			if (!atcCode) return false;

			// Convertiamo in maiuscolo per sicurezza
			const code = atcCode.toUpperCase();

			// I prefissi che identificano i veicoli
			const vehiclePrefixes = ["V07AB", "B05B", "B05A"];

			// .some() restituisce true se almeno un prefisso coincide con l'inizio del codice
			return vehiclePrefixes.some(function (prefix) {
				return code.startsWith(prefix);
			});
		},
		parseDrugDose(description) {
			if (!description) return { value: 0, unit: "ml" };

			var regex = /(\d+(?:[.,]\d+)?)\s*(ML|MG|G|MEQ|UI)/i;
			var match = description.match(regex);

			if (match) {
				return {
					value: parseFloat(match[1].replace(",", ".")),
					unit: match[2].toLowerCase(),
				};
			}
			return { value: 0, unit: "ml" };
		},
		removeComponent: function (index) {
			this.prescription.components.splice(index, 1);
		},
		onClickConfermaPrescrizione() {
			let validazione = this.validaDatiSoluzione();
			console.log(validazione);

			if (!validazione.esito) {
				this.$bvToast.toast(`${validazione.msg}`, {
					title: "Attenzione",
					autoHideDelay: 3000,
					variant: "danger",
				});
				return;
			}
			this.$emit("confermaPrescrizione", this.prescription.components, this.prescription.params);
			this.$bvToast.toast("Soluzione Confermata", {
				title: "Attenzione",
				autoHideDelay: 3000,
				variant: "success",
			});
		},
		validaDatiSoluzione() {
			let returnValue = { msg: "OK Validazione", esito: true };
			console.log(!this.prescription.components);

			if (!this.prescription.components) {
				returnValue.esito = false;
				returnValue.msg = "'Components' non valorizzato";
				return returnValue;
			}
			if (this.prescription.components.length == 1) {
				if (this.prescription.components[0].codiceProdotto == null) {
					returnValue.esito = false;
					returnValue.msg = "Inserire almeno una soluzione ";
					return returnValue;
				}
			}
			if (!this.prescription.params) {
				returnValue.esito = false;
				returnValue.msg = "Params non validi";
				return returnValue;
			}
			if (this.prescription.params.viaSomministrazione == null || this.prescription.params.viaSomministrazione == "") {
				returnValue.esito = false;
				returnValue.msg = "Parametro via somministrazione non valido";
				return returnValue;
			}

			if (this.ora == null) {
				returnValue.esito = false;
				returnValue.msg = "Parametro durata non valido, ora non valida!";
				return returnValue;
			}
			if (this.minuto == null) {
				returnValue.esito = false;
				returnValue.msg = "Parametro durata non valido, minuto non valido!";
				return returnValue;
			}

			return returnValue;
		},
		setFarmaciElistomero(prescrizioneFarmaci, pianificazione) {
			this.prescription.components = JSON.parse(JSON.stringify(prescrizioneFarmaci));
			this.setPianificazione(JSON.parse(pianificazione));
		},
		setPianificazione(pianificazione) {
			this.viaSomministrazione = pianificazione.viaSomministrazione;
			this.durata = pianificazione.durata;
			console.log(this.durata);

			let durataSplit = pianificazione.durata.split(":");
			this.ora = durataSplit[0];
			this.minuto = durataSplit[1];
		},
		onChangeOraMinuto(oraMinuto, valore) {
			if (oraMinuto == "ora") {
				this.durata = `${this.padStartCustom(valore, 2, "0")}:${this.minuto == null ? "00" : this.padStartCustom(this.minuto, 2, "0")}`;
			}
			if (oraMinuto == "minuto") {
				this.durata = `${this.ora == null ? "00" : this.padStartCustom(this.ora, 2, "0")}:${this.padStartCustom(valore, 2, "0")}`;
			}
			this.prescription.params.durata = this.durata;
		},
	},
};
</script>

<style scoped>
.header-left {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.header-right {
	display: flex;
	align-items: center;
	gap: 12px;
	height: 100%;
}

.sa-prescrizione-input-header {
	padding: 8px 12px;
	border-radius: 8px;
	border: none;
	font-weight: 600;
	background-color: rgba(255, 255, 255, 0.15);
	color: white;
	backdrop-filter: blur(6px);
}

.sa-prescrizione-input-header-custom {
	padding: 8px 12px;
	border-radius: 8px;
	border: none;
	font-weight: 600;
	background-color: rgba(255, 255, 255, 0.15);
	color: white;
	backdrop-filter: blur(6px);
	width: 50%;
}

.sa-prescrizione-input-header option {
	color: black;
}

.time-picker {
	min-width: 110px;
	padding: 8px 12px;
	border-radius: 8px;
	border: 1px solid #cbd5e1;
	background: #ffffff;
	font-weight: 700;
	font-size: 14px;
	color: #0f172a;
}

.time-picker:focus-within {
	border-color: #1e40af;
	box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.15);
}

.time-picker .mx-icon-calendar,
.time-picker .mx-icon-time {
	color: #1e40af;
}

.time-picker:hover {
	background: #f8fafc;
}

.sa-prescrizione-input-header-custom::placeholder {
	color: white;

	opacity: 1;
}
</style>
